import { AfterViewInit, Component, EventEmitter, Inject, inject, Input, LOCALE_ID, Output } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ReservationModel } from 'src/app/models/reservation.model';
import { ReservationTableComponent } from '../reservation-table/reservation-table.component';
import { MatIconModule } from '@angular/material/icon';
import { ReservationService } from 'src/app/services/reservation.service';
import html2pdf from 'html2pdf.js';
import { CommonModule, formatDate } from '@angular/common';
import { DocumentTypeLabelPipe } from 'src/app/shared/pipes/enum-label.pipe';

@Component({
  selector: 'app-inprogress-tab',
  standalone: true,
  imports: [ReservationTableComponent,
    MatIconModule,
    CommonModule,
    DocumentTypeLabelPipe],
  templateUrl: './inprogress-tab.component.html',
  styleUrl: './inprogress-tab.component.css'
})

export class InProgressTabComponent {

  private reservationSrv = inject(ReservationService);

  constructor(@Inject(LOCALE_ID) private locale: string) {

  }

  @Input() dataSource!: MatTableDataSource<ReservationModel>;
  @Input() totalCount!: number;
  @Input() pageSize!: number;
  @Input() pageIndex!: number;
  @Input() isLoading!: boolean;
  @Input() errorClassFn!: (row: ReservationModel) => string;

  @Input() canCheckInFn!: (reservation: ReservationModel) => boolean;
  @Input() canCheckOutFn!: (reservation: ReservationModel) => boolean;
  @Input() canCancelFn!: (reservation: ReservationModel) => boolean;
  @Input() canEditFn!: (reservation: ReservationModel) => boolean;
  @Input() canRegisterPaymentFn!: (reservation: ReservationModel) => boolean;

  displayedColumns = ['responsible', 'document', 'checkOutDate', 'id', 'status', 'actions'];

  @Output() pageChange = new EventEmitter<PageEvent>();
  @Output() actionClick = new EventEmitter<any>();
  details: any[] = [];
  today = new Date();

  ngOnInit(): void {
  }

  printInProgressList() {
    this.details = [];
    const reservations = this.dataSource.data;
    const requests = reservations.map(r =>
      this.reservationSrv.getById(r.id).toPromise()
    );

    Promise.all(requests).then(fullReservations => {

      fullReservations.forEach(reservation => {
        reservation.reservationDetails.forEach(detail => {
          const roomNumber = detail.room?.number ?? '';
          detail.guests.forEach(guest => {
            this.details.push({
              roomNumber,
              firstName: guest.firstName,
              lastName: guest.lastName,
              documentType: guest.documentType,
              documentNumber: guest.documentNumber,
              originAddress: guest.originAddress,
              countryOfOrigin: guest.countryOfOrigin
            })
          });
        });
      });
      this.details.sort((a, b) => a.roomNumber - b.roomNumber);
      this.generatePdf()
    });
  }

  generatePdf() {
    const element = document.getElementById('printablecontent');
    if (element) {
      html2pdf()
        .set({ filename: `Reporte de huéspedes - ${formatDate(this.today, 'dd-MM-yyyy-HH-mm', this.locale)}.pdf`, margin: 10 })
        .from(element)
        .save();
    }
  }
}
